import { filterObj } from 'ui-lib'

import fetchApi from '../fetch-api'
import * as t from 'io-ts'

export const CompanySearchIO = t.type({
  companyID: t.string,
  name: t.string,
  licence_no: t.string,
});

export type CompanySearch = t.TypeOf<typeof CompanySearchIO>;

const companySearchQuery = ({
  searchKey,
  separatedSearchKey,
}: {
  searchKey: string
  separatedSearchKey?: string
}) => ({
  queryKey: [
    'search-configurations',
    filterObj(searchKey, (_, value) => !!value),
  ],
  queryFn: () =>
    fetchApi({
      service: 'admin-service',
      pathname: `/search-company?searchQuery=${searchKey}`,
      headers:{method: 'GET'},
      codec: t.array(CompanySearchIO),
    }),
  keepPreviousData: true,
})

export default companySearchQuery
